import axios from "axios";

//IMPORT API ROUTE URL
import { FAVORITE_PROFILE_ROUTE } from "./apiRoutes";

const favoriteProfiles = (user_slug) => {
  var postData = new FormData();

  postData.append("user_slug", user_slug);

  return axios
    .post(FAVORITE_PROFILE_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default favoriteProfiles;
